var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { Slide } from '@material-ui/core';
import { values } from '../../utils';
import { CategoryList } from './CategoryList';
export var Category = function (_a) {
    var categories = _a.categories, onSelect = _a.onSelect;
    var _b = React.useState([]), path = _b[0], setPath = _b[1];
    var handleNextClick = function (id) {
        if (id) {
            return setPath(function (prev) { return __spreadArray(__spreadArray([], prev, true), [id], false); });
        }
        return setPath([]);
    };
    var c = path.reduce(function (acc, p) {
        var _a;
        return values(((_a = acc.find(function (c) { return c.id === p; })) === null || _a === void 0 ? void 0 : _a.sub) || acc);
    }, categories);
    return (React.createElement("div", null, path.length > 0 ? (React.createElement(Slide, { direction: 'left', in: path.length > 0, mountOnEnter: true, unmountOnExit: true },
        React.createElement("div", null,
            React.createElement(CategoryList, { categories: c, path: path, onNextClick: handleNextClick, onSelect: onSelect })))) : (React.createElement(Slide, { direction: 'right', in: path.length === 0, mountOnEnter: true, unmountOnExit: true },
        React.createElement("div", null,
            React.createElement(CategoryList, { categories: c, path: path, onNextClick: handleNextClick, onSelect: onSelect }))))));
};
//# sourceMappingURL=Category.js.map